export const NOTIFICASTATUSES = {
  CREATED: "NOTCRE",
  READ: "NOTREA",
  DELETED: "NOTELI",
  SENT: "NOTINV",
  PROCESSEDED: "NOTEVA",
};
